<template>
    <div class="h-full relative p-6 lg:p-12">
        <!--<div
            class="absolute inset-0 bg-gray-200 bg-opacity-80 z-10"
            v-if="!step5Complete"
        ></div>-->
        <div
            class="absolute inset-0 z-20 bg-gray-500 bg-opacity-90 transition-opacity"
            v-if="!step5Complete"
        ></div>
        <div class="absolute inset-0 z-20" v-if="!step5Complete">
            <div class="absolute inset-0 z-20 w-100 overflow-y-auto">
                <div
                    class="flex min-h-full items-center justify-center p-4 text-center sm:p-0"
                >
                    <div
                        class="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-sm sm:p-6"
                    >
                        <div>
                            <div
                                class="mx-auto flex items-center justify-center"
                            >
                                <span class="fa-stack relative z-20 fa-lg">
                                    <i
                                        class="fa-solid fa-circle fa-stack-2x text-red-100"
                                    ></i>
                                    <i
                                        class="fa-regular fa-exclamation fa-stack-1x fa-inverse text-red-700"
                                    ></i>
                                </span>
                            </div>
                            <div class="mt-3 text-center sm:mt-5">
                                <h3
                                    class="text-base font-semibold leading-6 text-gray-900"
                                    id="modal-title"
                                >
                                    Go Back to the Previous Step
                                </h3>
                                <div class="mt-2">
                                    <p class="text-sm text-gray-500">
                                        You must complete the previous step
                                        before continuing.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="!stepComplete">
            <div class="rounded-lg bg-white p-6 shadow-lg mb-12">
                <h3 class="text-lg xl:text-xl font-semibold leading-6 mb-3">
                    Sit Tight
                    <span class="fa-stack">
                        <i
                            class="fa-solid fa-circle fa-stack-2x text-orange-100"
                        ></i>
                        <i
                            class="fa-regular fa-timer fa-stack-1x fa-inverse text-orange-700"
                        ></i>
                    </span>
                </h3>
                <p class="text-base mb-3">Now for the hard part!</p>
                <p class="text-base mb-3">
                    Wait until
                    <span class="font-semibold">1/1/2025</span>

                    <span v-if="daysLeft">
                        (
                        <span class="font-semibold">{{ daysLeft }}</span>
                        days left to go )
                    </span>

                    to meet your minimum spend on both cards.
                </p>
            </div>
            <div class="rounded-lg bg-white p-6 shadow-lg mb-12">
                <p class="text-base mb-3">
                    <strong>Quick Tips to Stay On Track:</strong>
                </p>
                <ul class="list-disc pl-5">
                    <li class="mb-2">
                        Continue keeping both cards securely stashed away.
                    </li>
                    <li class="mb-2">
                        Resist the urge to give the cards to your P2 or to
                        create authorized user accounts.
                    </li>
                    <li class="mb-2">
                        Avoid the temptation to add either card to autopay
                        settings or save them as payment methods on shopping
                        sites like Amazon and Walmart+, and yes, mobile wallets!
                    </li>
                    <li class="mb-2">
                        Remember, the
                        <strong><em>annual fee does NOT count</em></strong>
                        towards your minimum spend requirement.
                    </li>
                </ul>
            </div>
            <img
                src="/images/companionpass/companionpass_waituntil112025.png"
                class="mx-auto mb-5 lg:mb-10"
                alt="My10X"
            />
        </div>
        <div v-if="stepComplete">
            <div class="rounded-lg bg-white px-4 py-5 shadow-lg mb-12">
                <h3 class="text-lg xl:text-xl font-semibold leading-6 mb-3">
                    Step 6 Complete: Spend Away
                    <span class="fa-stack">
                        <i
                            class="fa-solid fa-circle fa-stack-2x text-green-100"
                        ></i>
                        <i
                            class="fa-regular fa-check fa-stack-1x fa-inverse text-green-700"
                        ></i>
                    </span>
                </h3>
                <p>
                    You're free and clear to spend away on both of your new
                    Southwest Credit Cards now.
                </p>
            </div>
            <div class="relative">
                <div class="absolute top-[25%] right-[50%] translate-x-2/4">
                    <span
                        class="fa-stack text-2xl md:text-3xl lg:text-5xl leading-loose flex items-center"
                    >
                        <i
                            class="fa-solid fa-circle fa-stack-2x text-green-100"
                        ></i>
                        <i
                            class="fa-regular fa-check fa-stack-1x fa-inverse text-green-700"
                        ></i>
                    </span>
                </div>
                <img
                    src="/images/companionpass/companionpass_waituntil112025.png"
                    class="mx-auto mb-5 lg:mb-10"
                    alt="My10X"
                />
            </div>
        </div>
    </div>
</template>
<script>
import { mapState, mapActions } from 'pinia';
import { useCompanionPassStore } from '@/store/companionpass';

export default {
    name: 'StepSix',
    props: {},
    components: {},
    data: () => ({}),
    computed: {
        ...mapState(useCompanionPassStore, ['completeSteps']),
        cdnUrl() {
            return window.cdnUrl;
        },
        stepContent() {
            return this.getStepContent(6);
        },
        step() {
            return this.getStep(6);
        },
        step1() {
            return this.getStep(1);
        },
        step5() {
            return this.getStep(5);
        },
        stepComplete() {
            return 6 in this.completeSteps ? true : false;
        },
        step5Complete() {
            return 5 in this.completeSteps ? true : false;
        },
        daysLeft() {
            return this.step1?.days_left;
        },
    },
    methods: {
        ...mapActions(useCompanionPassStore, ['getStep', 'getStepContent']),
    },
    mounted() {},
};
</script>
